// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Rt-l","tab":"ProcedureTabs_tab__2QjZX"};